import { render } from "./AppSidebar.vue?vue&type=template&id=6f35227a&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=6f35227a&scoped=true&lang=css"
import "./AppSidebar.vue?vue&type=style&index=1&id=6f35227a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f35227a"]])

export default __exports__